import { app } from './bootstrap/core';
import { appState } from './app.state';
import { appComponent } from './app.component';
import appConfig from './app.config.json';

// Configure app states
app.config(appState);

// Application component
app.component('app', appComponent);

// Create application wide configuration
app.factory('appConfig', (configFactory) => {
  'ngInject';
  return configFactory.create(appConfig, {});
});

// Apply some global configuration...
app.config(
  (
    $locationProvider,
    $urlRouterProvider,
    $httpProvider,
    $translateProvider,
  ) => {
    'ngInject';

    $translateProvider.useMessageFormatInterpolation();

    // Rely on history.pushState to change urls where supported.
    // Will fall back to hash-prefixed paths in browsers that do not support.
    $locationProvider.html5Mode(true).hashPrefix('!');

    // If the user enters a URL that doesn't match any known URL (state),
    // send them to `/` by default.
    $urlRouterProvider.otherwise('/');

    // Error handling
    $httpProvider.interceptors.push('errorInterceptor');

    // Handle Angular IE Caching issue for $http
    // Initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] =
      'Mon, 26 Jul 1997 05:00:00 GMT';
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
  },
);

// Application runtime
app.run(
  (
    $rootScope,
    $log,
    $trace,
    $transitions,
    envService,
    configService,
    appConfig,
    trackingService,
  ) => {
    'ngInject';
    const config = appConfig.get();

    // Make app configuration globally accessible to all scopes
    $rootScope.$config = configService.config;

    // Enable tracing (for tracking)
    // $trace.enable(1);

    // Enable tracking (only for production!)
    if (configService.isProduction() && config.app.tracking) {
      trackingService.activate(config.app.tracking);
      $transitions.onSuccess(true, ($transition$) => {
        let to = $transition$.to();
        let toParams = $transition$.params('to');
        trackingService.pageTrack(to.url, to.name, toParams);
      });
    }
  },
);



// WEBPACK FOOTER //
// ./src/app/app.js